import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { bulkItems } from 'common/api/panels';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import fetchItems from './fetchItems';

export default (ids, value, filterData, callback) => (dispatch) => {
    dispatch(actions[BULK_UPDATE_ITEMS]());

    const items = ids.map((id) => id);

    bulkItems({ status_flag: value, items })
        .then(() => {
            dispatch(actions[BULK_UPDATE_ITEMS_SUCCESS]());
            if (!isEmpty(filterData)) dispatch(fetchItems(filterData));
            if (value === 'deleted')
                showToast({ body: i18next.t('It was successfully removed') });
            if (value === 'archived')
                showToast({ body: i18next.t('It was successfully archived') });
            if (value === 'active')
                showToast({
                    body: i18next.t('It was successfully unarchived'),
                });
            if (callback) callback();
        })
        .catch((error) => {
            dispatch(
                actions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
